<template>
  <div>
    <contactFormModal ref="contactFormModal" />
    <banner />
    <div class="d-inline-block" style="width: 25%">
      <h2>For more information:</h2>
      <div style="width: 70%; margin: 0 auto;">
        <b-row class="justify-content-center my-4 mx-0">
          <b-button variant="primary" class="info-button" @click="buttonClick('Investors')">Investors</b-button>
        </b-row>
        <b-row class="justify-content-center my-4 mx-0">
          <b-button variant="primary" class="info-button" @click="buttonClick('Data and Analytics Partners')">Data and Analytics Partners</b-button>
        </b-row>
        <b-row class="justify-content-center my-4 mx-0">
          <b-button variant="primary" class="info-button" @click="buttonClick('Issuers')">Issuers</b-button>
        </b-row>
      </div>
    </div>
    <HomePageFooter />
  </div>
</template>

<script>
import Login from './Login'
import ContactFormModal from './ContactFormModal'
import Banner from './homePageComponents/Banner';
import HomePageFooter from './homePageComponents/HomePageFooter';

export default {
  data() {
    return {}
  },
  methods: {
    buttonClick(type) {
      this.$refs.contactFormModal.showModal(type)
    }
  },
  components: {
    Login,
    ContactFormModal,
    Banner,
    HomePageFooter
  }
}
</script>

<style lang="scss" scoped>
.info-button {
  width: 100%;
  white-space: normal;
  font-size: 20px !important;
}
</style>
